import ToastPresentationPropsDefault, {
    toasterProps as toasterPropsDefault,
} from "@insite/mobius/Toast/presentationProps";
import { get } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import { screen } from "@stoneage/XDL/Helpers";
import colors from "@stoneage/XDL/PreStyle/colors";
import { xBaseTheme } from "@stoneage/XDL/types";
import { css } from "styled-components";

const iconColor = get(colors, "common.ui1");

export default {
    defaultProps: {
        ...ToastPresentationPropsDefault,
        cssOverrides: {
            toast: css`
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                border: none;
                border-top: ${({ messageType, theme }: any) => `4px solid ${resolveColor(messageType, theme)}`};
                background: ${getColor("common.white")};
                box-shadow: 0 0 25px 0 rgba(79, 79, 119, 0.18);
                @media print {
                    display: none;
                }
                ${screen("lte","sm")`
                    max-width: 90%;
                    right: 20px;
                `}
            `,
            toastBody: css`
                &&& {
                    margin: 12px 10px;
                    &,
                    * {
                        font-size: 13px;
                        line-height: 15px;
                    }
                    max-height: 500px;
                    align-items: flex-start;
                }
            `,
        },
        iconProps: {
            size: 20,
            css: css`
                margin: auto 12px auto 0;
                width: 20px;
                height: 20px;
            `,
        },
        bodyTypographyProps: {},
        closeButtonProps: {
            color: "transparent",
            css: css`
                &,
                button {
                    background: transparent !important;
                    border: 0 !important;
                    box-shadow: none !important;
                }

                padding-left: 5px;
                padding-right: 5px;
                margin-right: 2px;
                margin-top: 0;
            `,
        },
        closeButtonIconProps: {
            color: iconColor,
            css: css`
                width: 20px;
                height: 20px;
            `,
        },
    },
    toasterProps: { toasterPropsDefault },
} as xBaseTheme["toast"];
